<template>
  <div v-if="visible" class="audit-standard-cycle-details">
    <div class="cycle-detail-title">
      <span>표준별 차수 검토</span>
      <span v-if="isMixed" class="cycle-badge mixed">혼합차수</span>
    </div>
    <div v-if="isMixed" class="cycle-help">
      하나의 심사번호 안에 표준별 차수가 섞여 있습니다. 심사계획서·심사보고서에는 아래 “이번 신청 차수”를 기준으로 표시합니다.
    </div>
    <div class="cycle-detail-list">
      <div
        v-for="(detail, index) in normalizedDetails"
        :key="`${detail.standard}-${detail.cert_no || index}`"
        class="cycle-detail-item"
      >
        <div class="cycle-standard">
          {{ standardLabel(detail.standard) }}
        </div>
        <div class="cycle-content">
          <div class="cycle-line primary">
            <span class="cycle-label">이번 신청 차수</span>
            <strong>{{ auditDisplay(detail.audit_type, detail.audit_degree) }}</strong>
          </div>
          <div class="cycle-line">
            <span class="cycle-label">인증번호</span>
            <span>{{ detail.cert_no || '-' }}</span>
          </div>
          <div v-if="showPrevious" class="cycle-line">
            <span class="cycle-label">직전 심사</span>
            <span>{{ previousText(detail) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auditDisplay, isMixedDegree, normalizeDetailRows, standardLabel } from '@/utils/auditCycleDetails'

export default {
  name: 'AuditStandardCycleDetails',
  props: {
    details: {
      type: Array,
      default: () => []
    },
    auditDegree: {
      type: String,
      default: ''
    },
    showWhenSingle: {
      type: Boolean,
      default: false
    },
    showPrevious: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    normalizedDetails() {
      const order = { qms: 1, ems: 2, ohsms: 3, cms: 4, cgmp: 4 }
      return normalizeDetailRows(this.details).sort((a, b) => {
        return (order[a.standard] || 99) - (order[b.standard] || 99)
      })
    },
    isMixed() {
      return isMixedDegree(this.auditDegree)
    },
    visible() {
      return this.normalizedDetails.length > 0 && (this.isMixed || this.showWhenSingle)
    }
  },
  methods: {
    auditDisplay,
    standardLabel,
    previousText(detail) {
      const type = detail.previous_audit_type || ''
      const degree = detail.previous_audit_degree || ''
      const no = detail.previous_audit_no || ''
      const step = [type, degree].filter(Boolean).join(' ')
      return [no, step].filter(Boolean).join(' / ') || '-'
    }
  }
}
</script>

<style scoped>
.audit-standard-cycle-details {
  font-size: 13px;
  text-align: left;
}

.cycle-detail-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  margin-bottom: 6px;
}

.cycle-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
}

.cycle-badge.mixed {
  color: #084298;
  background: transparent;
  border: 1px solid #9ec5fe;
}

.cycle-help {
  margin-bottom: 8px;
  padding: 6px 8px;
  color: #664d03;
  background: transparent;
  border: 1px solid #ffecb5;
  border-radius: 4px;
  line-height: 1.45;
}

.cycle-detail-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 8px;
}

.cycle-detail-item {
  display: flex;
  gap: 10px;
  padding: 8px;
  background: transparent;
  border: 1px solid #dee2e6;
  border-radius: 6px;
}

.cycle-standard {
  flex: 0 0 62px;
  align-self: flex-start;
  padding: 4px 6px;
  text-align: center;
  font-weight: 700;
  color: #495057;
  background: transparent;
  border-radius: 4px;
}

.cycle-content {
  min-width: 0;
  flex: 1;
}

.cycle-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  line-height: 1.45;
  word-break: break-word;
}

.cycle-line.primary strong {
  color: #0d6efd;
}

.cycle-label {
  flex: 0 0 96px;
  color: #6c757d;
  font-weight: 600;
  white-space: nowrap;
}
</style>
